import VectorProps from "./VectorProps";

export default function Duplicate(props: VectorProps) {
  const {
    className = "",
    fill = "currentColor",
    handleClick = () => null,
    height,
    width,
  } = props;
  // from https://www.figma.com/design/LyX9wbSKd81UvXFeq58wMx/Foodsteps-Design-Library?node-id=1501-1661&t=yi0FVhEgDbmmfgHq-0
  return (
    <svg
      className={className}
      fill={fill}
      height={height ?? width}
      onClick={handleClick}
      viewBox="0 0 20 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.61538 4.61538H3.84615C2.82615 4.61538 1.84769 5.02077 1.12615 5.74154C0.405385 6.46308 0 7.44154 0 8.46154C0 10.7515 0 13.8638 0 16.1538C0 17.1738 0.405385 18.1523 1.12615 18.8738C1.84769 19.5946 2.82615 20 3.84615 20C6.13615 20 9.24846 20 11.5385 20C12.5585 20 13.5369 19.5946 14.2585 18.8738C14.9792 18.1523 15.3846 17.1738 15.3846 16.1538V15.3846H16.1538C17.1738 15.3846 18.1523 14.9792 18.8738 14.2585C19.5946 13.5369 20 12.5585 20 11.5385C20 9.24846 20 6.13615 20 3.84615C20 2.82615 19.5946 1.84769 18.8738 1.12615C18.1523 0.405385 17.1738 0 16.1538 0C13.8638 0 10.7515 0 8.46154 0C7.44154 0 6.46308 0.405385 5.74154 1.12615C5.02077 1.84769 4.61538 2.82615 4.61538 3.84615V4.61538ZM13.8462 8.46154V16.1538C13.8462 16.7662 13.6031 17.3531 13.17 17.7854C12.7377 18.2185 12.1508 18.4615 11.5385 18.4615C9.24846 18.4615 6.13615 18.4615 3.84615 18.4615C3.23385 18.4615 2.64692 18.2185 2.21462 17.7854C1.78154 17.3531 1.53846 16.7662 1.53846 16.1538C1.53846 13.8638 1.53846 10.7515 1.53846 8.46154C1.53846 7.84923 1.78154 7.26231 2.21462 6.83C2.64692 6.39692 3.23385 6.15385 3.84615 6.15385C6.13615 6.15385 9.24846 6.15385 11.5385 6.15385C12.1508 6.15385 12.7377 6.39692 13.17 6.83C13.6031 7.26231 13.8462 7.84923 13.8462 8.46154ZM15.3846 13.8462H16.1538C16.7662 13.8462 17.3531 13.6031 17.7854 13.17C18.2185 12.7377 18.4615 12.1508 18.4615 11.5385C18.4615 9.24846 18.4615 6.13615 18.4615 3.84615C18.4615 3.23385 18.2185 2.64692 17.7854 2.21462C17.3531 1.78154 16.7662 1.53846 16.1538 1.53846C13.8638 1.53846 10.7515 1.53846 8.46154 1.53846C7.84923 1.53846 7.26231 1.78154 6.83 2.21462C6.39692 2.64692 6.15385 3.23385 6.15385 3.84615V4.61538H11.5385C12.5585 4.61538 13.5369 5.02077 14.2585 5.74154C14.9792 6.46308 15.3846 7.44154 15.3846 8.46154V13.8462Z"
        fill={fill}
      />
    </svg>
  );
}
